<template lang="html">
  <div class="cw-contact fill-mobile">
    <div class="card box">
      <div class="scrolling-content">
        <div class="card-image">
          <div class="hero is-small is-black">
            <div class="hero-body has-text-centered">
              <!-- <span class="icon is-large has-text-primary">
              <i class="las la-2x la-phone"></i>
            </span> -->
              <icon name="contact" scale="5"></icon>
              <h1 class="title is-3">Contact Us</h1>
            </div>
          </div>
        </div>
        <div class="card-content">
          <div class="content">
            <p class="is-size-5 has-text-centered">
              We are here to help. If you need to place or cancel an order, or
              confirm a rush order contact dispatch.
            </p>
          </div>
          <section
            class="section is-horizontal-paddingless is-padded-medium is-top-paddingless"
          >
            <h3 class="is-size-3 has-border-bottom is-padded-small">Call</h3>
            <a class="is-black" href="tel:1-317-783-1500">
              <cw-list-cell
                class="has-border-bottom"
                title="Main"
                subtitle="(317) 783-1500"
                :leftIconProps="callIcon"
            /></a>
            <a class="is-black" href="tel:1-317-783-1500+4">
              <cw-list-cell
                class="has-border-bottom"
                title="Dispatch"
                subtitle="(317) 783-1500 +4"
                :leftIconProps="callIcon"
              />
            </a>
          </section>

          <section
            class="section is-horizontal-paddingless is-padded-medium is-top-paddingless"
          >
            <h3 class="is-size-3 has-border-bottom is-padded-small">Email</h3>
            <cw-list-cell
              class="has-border-bottom"
              title="Information"
              subtitle="info@CallCW.com"
              @click="sendMail('info@CallCW.com')"
              :leftIconProps="mailIcon"
            />
            <cw-list-cell
              class="has-border-bottom"
              title="Dispatch"
              subtitle="dispatch@CallCW.com"
              @click="sendMail('dispatch@CallCW.com')"
              :leftIconProps="mailIcon"
            />
          </section>

          <section
            class="section is-horizontal-paddingless is-padded-medium is-top-paddingless"
          >
            <h3 class="is-size-3 has-border-bottom is-padded-small">Support</h3>
            <cw-list-cell
              class="has-border-bottom"
              title="App Support"
              subtitle=""
              @click="showSupport"
              :leftIconProps="mailIcon"
            />
          </section>
          <div class="is-padded-small centerit">
            <cw-app-version />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cw-contact',
  data() {
    return {
      callIcon: {
        bulmaIcon: true,
        name: 'fa-phone',
        colorClass: 'has-text-primary',
        scale: 'is-medium',
      },
      mailIcon: {
        bulmaIcon: true,
        name: 'fa-envelope',
        colorClass: 'has-text-primary',
        scale: 'is-medium',
      },
    };
  },
  methods: {
    sendMail(to) {
      open(`mailto:${to}`, '_self');
    },
    showSupport() {
      this.$modal.hide('contact');
      this.$router.push('/support');
    },
  },
};
</script>

<style lang="stylus" scoped>
.cw-contact .hero {
  background: #231F20

  .title {
    color: white;
  }
}
</style>
